const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Get top utility configuration
export const getTopUtilityConfig = async () => {
  const response = await fetch(`${BASE_URL}/api/top-utility/config`);
  return response.json();
};

// Update top utility configuration
export const updateTopUtilityConfig = async (configData) => {
  const response = await fetch(`${BASE_URL}/api/top-utility/config`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(configData),
  });
  return response.json();
};

// Get all announcements. Pass includeInactive=true to also get draft/inactive ones (admin panel).
export const getAnnouncements = async (includeInactive = false) => {
  const response = await fetch(`${BASE_URL}/api/top-utility/announcements${includeInactive ? '?all=true' : ''}`);
  return response.json();
};

// Create new announcement
export const createAnnouncement = async (announcementData) => {
  const response = await fetch(`${BASE_URL}/api/top-utility/announcements`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(announcementData),
  });
  return response.json();
};

// Update announcement
export const updateAnnouncement = async (id, announcementData) => {
  const response = await fetch(`${BASE_URL}/api/top-utility/announcements/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(announcementData),
  });
  return response.json();
};

// Delete announcement
export const deleteAnnouncement = async (id) => {
  const response = await fetch(`${BASE_URL}/api/top-utility/announcements/${id}`, {
    method: 'DELETE',
  });
  return response.json();
};

// Reorder announcements
export const reorderAnnouncements = async (announcements) => {
  const response = await fetch(`${BASE_URL}/api/top-utility/announcements/reorder`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ announcements }),
  });
  return response.json();
};
